// extracted by mini-css-extract-plugin
export var subscribeBox = "subscribe-module--subscribeBox--3jO1v";
export var emailInput = "subscribe-module--emailInput--Zx7vS";
export var subscribeHeader = "subscribe-module--subscribeHeader--2Bh-x";
export var subscribeSubtext = "subscribe-module--subscribeSubtext--2OJab";
export var subscribeDisclaimer = "subscribe-module--subscribeDisclaimer--mTin9";